export default __webpack_public_path__ + "static/media/Group1466101.4abd731f.svg";